<div class="wrapper">
  Module disabled
  <!--
  <div class="table-container" *qmLoading="!initReady">
    <qm-element-filters [alwaysActive]="true" [filterDefinitions]="filterDefinitions" [typeFilter]="false"
                        (filtersChanged)="filtersChanged($event)"></qm-element-filters>
    <div *qmLoading="loading" id="plotly" style="display: flex; flex: 1 1;"></div>
  </div>
  -->
</div>
